
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { padding_p6, boxShadow_shadow, borderRadius_roundedLg, margin_mxAuto, maxWidth_wXl, fontWeight_fontMedium, margin_mt2, padding_px4, textAlign_center, justifyContent_justifyCenter, cursor_cursorPointer, textDecoration_underline, margin_mt4, flexDirection_flexRow, flexDirection_flexCol, fontWeight_fontBold, fontSize_textXl, gap_gap$002D2, alignItems_itemsCenter, display_flex, margin_mt1, fontSize_textSm, fontWeight_fontSemibold, fontSize_textLg, margin_mb4, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { length, item, ofArray, singleton } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { backgroundColor_bgSurface, textColor_textNeutral400, textColor_textSuccess600, padding_py12, textColor_textNeutral800, hover, textColor_textNeutral600, sm, textColor_textNeutral500, textColor_textNeutral900 } from "../TailwindExtensions.js";
import { printf, toText } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { useEffect, createElement } from "react";
import React from "react";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { ClientTypes_Msg } from "../ClientTypes.js";
import { Clock_system } from "../Clock.js";
import { disposeSafe } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { newPhotoKey, unitsForAdd, weekdayAndDate, DailyLogEntryForm } from "./DailyLogView.js";
import { AddDailyLogRequest } from "../Shared.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { centeredSpinner } from "../Layout/Interactions.js";

function challengeContextHeader(challenge) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton(margin_mb4))], ["children", [HtmlHelper_createElement("h2", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton(toText(printf("\"%s\""))(challenge.Title))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, margin_mt1]))], ["children", singleton(toText(printf("%.1f / %.0f %s"))(challenge.CurrentTotal)(challenge.TargetAmount)(challenge.UnitType))]]))]]]));
}

function challengeCounter(currentIndex, totalCount) {
    let arg;
    if (totalCount <= 1) {
        return defaultOf();
    }
    else {
        return HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton((arg = ((currentIndex + 1) | 0), toText(printf("(%d of %d)"))(arg)(totalCount)))]]));
    }
}

function sectionHeading(currentIndex, totalCount) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, margin_mb4]))], ["children", [createElement(icon, {
        name: new IconName(0, []),
        size: new IconSize(2, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("h1", ofArray([["className", tw(ofArray([fontSize_textXl, fontWeight_fontBold, textColor_textNeutral900]))], ["children", singleton("Daily Check-in")]])), challengeCounter(currentIndex, totalCount)]]]));
}

function skipControls(isSingleChallenge, dispatch) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, sm(flexDirection_flexRow), gap_gap$002D2, margin_mt4]))], ["children", [HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600, hover(textColor_textNeutral800), hover(textDecoration_underline), cursor_cursorPointer]))], ["children", singleton(isSingleChallenge ? "Skip for now" : "Skip this challenge")], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(122, []));
    }]])), HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600, hover(textColor_textNeutral800), hover(textDecoration_underline), cursor_cursorPointer]))], ["children", singleton(isSingleChallenge ? "Go to dashboard" : "Skip all · Go to dashboard")], ["onClick", (_arg_1) => {
        dispatch(new ClientTypes_Msg(123, [Clock_system.UtcNow()]));
    }]]))]]]));
}

function AllDoneView($props) {
    let arg_1;
    const dispatch = $props.dispatch;
    const loggedCount = $props.loggedCount;
    useEffect(() => {
        const setup = (() => {
        let disp;
        const timerId = window.setTimeout(() => {
            dispatch(new ClientTypes_Msg(126, []));
        }, 1500);
        disp = {
            Dispose() {
                window.clearTimeout(timerId);
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, []);;
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, textAlign_center, padding_py12, padding_px4]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([textColor_textSuccess600, margin_mb4]))], ["children", [createElement(icon, {
        name: new IconName(32, []),
        size: new IconSize(2, []),
        weight: new IconWeight(1, []),
    })]]])), HtmlHelper_createElement("h2", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral800]))], ["children", singleton("All caught up!")]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, margin_mt1]))], ["children", singleton((arg_1 = ((loggedCount === 1) ? "" : "s"), toText(printf("You\'ve logged progress for all %d active challenge%s today."))(loggedCount)(arg_1)))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral400, margin_mt2]))], ["children", singleton("Loading your dashboard...")]]))]]]));
}

/**
 * Renders the "You also missed N days" hint with a link to the Manage page's log section.
 * Renders nothing when no days were missed. Following the link does not set the skip cooldown.
 */
export function catchUpHint(challenge, dispatch) {
    let value_2, arg_1;
    if (challenge.MissedDayCount === 0) {
        return defaultOf();
    }
    else {
        return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textSm, textColor_textNeutral600, margin_mt4]))], ["children", [createElement(icon, {
            name: new IconName(35, []),
            size: new IconSize(0, []),
            weight: new IconWeight(0, []),
        }), (value_2 = ((arg_1 = ((challenge.MissedDayCount === 1) ? "" : "s"), toText(printf("You also missed %d day%s on this challenge."))(challenge.MissedDayCount)(arg_1))), createElement("span", defaultOf_1(), value_2)), HtmlHelper_createElement("a", ofArray([["className", tw(ofArray([fontWeight_fontMedium, textDecoration_underline]))], ["href", toText(printf("/challenges/%O#daily-log"))(challenge.ChallengeId)], ["children", singleton("Catch up →")], ["onClick", (e) => {
            e.preventDefault();
            dispatch(new ClientTypes_Msg(127, [challenge.ChallengeId]));
        }]]))]]]));
    }
}

function PromptingView($props) {
    let arg;
    const dispatch = $props.dispatch;
    const model = $props.model;
    const currentIndex = $props.currentIndex;
    const challenges = $props.challenges;
    const challenge = item(currentIndex, challenges);
    const totalCount = length(challenges) | 0;
    const isSingleChallenge = totalCount <= 1;
    const today = challenge.Today;
    let authToken;
    const matchValue = model.Auth;
    authToken = ((matchValue.tag === 1) ? matchValue.fields[0] : undefined);
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([maxWidth_wXl, margin_mxAuto, backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6]))], ["children", [sectionHeading(currentIndex, totalCount), challengeContextHeader(challenge), createElement(DailyLogEntryForm, {
        unitType: challenge.UnitType,
        heading: (arg = weekdayAndDate(today), toText(printf("Today · %s"))(arg)),
        unitsLocked: false,
        isTodayForm: true,
        onDraftChanged: (value_2) => {
        },
        onSubmit: (units, title, note, photoChange) => {
            dispatch(new ClientTypes_Msg(124, [new AddDailyLogRequest(challenge.ChallengeId, today, unitsForAdd(units), title, note, newPhotoKey(photoChange))]));
        },
        isSubmitting: model.SubmittingDailyLog,
        submitError: unwrap(model.DailyLogSubmitError),
        photoUpload: model.PhotoUpload,
        dispatch: dispatch,
        authToken: unwrap(authToken),
    }), skipControls(isSingleChallenge, dispatch), catchUpHint(challenge, dispatch)]]]));
}

/**
 * Top-level interception view dispatched from RouteDispatch when interception is active.
 */
export function view(model, dispatch) {
    const matchValue = model.DailyLogInterception;
    switch (matchValue.tag) {
        case 2:
            return createElement(PromptingView, {
                challenges: matchValue.fields[0],
                currentIndex: matchValue.fields[1],
                model: model,
                dispatch: dispatch,
            });
        case 3:
            return createElement(AllDoneView, {
                loggedCount: matchValue.fields[0],
                dispatch: dispatch,
            });
        case 0:
            return defaultOf();
        default:
            return centeredSpinner;
    }
}

//# sourceMappingURL=DailyLogInterceptionView.js.map
